//  开班单位相关 api
import request from '@/api/request'

// 获取修改页面数据
export function classunitEditInitApi(id:string){
    let url = '/api/manager/classunit/edit/init';
    let data = {
        "id":id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 更新修改页面
export function classunitEditSaveApi(data:any){
    let url = '/api/manager/classunit/edit/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 增加文章
export function classunitAddApi(data:any){
    let url = '/api/manager/classunit/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}


// 获取学习班类型列表
export function optionsApi(data:any){
    let url = '/api/manager/classunit/options';
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function cascaderOptionsOwnApi(){
    let url = '/api/manager/classunit/options/cascader/own';
    // const data = {
    //     "pid": pid,
    //     "unitid":unitid
    // }
    return request({
        url: url,
        method: 'post'
    })
}

